// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[disabled][data-v-37b72d22]{background-color:transparent;border-color:transparent;box-shadow:none;color:#d1d2d7!important;pointer-events:none}", ""]);
// Exports
module.exports = exports;
